module.exports = __webpack_public_path__ + "images/vmleasing98d7b88d7f3e4412bdcad3c1f1d9f0cd.png";